import { getField, updateField } from "vuex-map-fields";
import { VuexModule, Module, Action } from "vuex-module-decorators";
import RatingService from "@/services/rating.service";
import { RatingDataDto, RatingDto, RatingFormDto } from "@/types/rating.type";
import { RatingStatus } from "@/common/constants";

@Module({ namespaced: true })
class Ratings extends VuexModule {
  openRatings: RatingDto[] = [];
  closedRatings: RatingDto[] = [];
  ratingData: RatingDataDto | null = null;

  @Action({ rawError: true })
  async getData(): Promise<void> {
    const data = await RatingService.getDataAsync();

    this.context.commit("updateField", {
      path: "ratingData",
      value: data
    });
  }

  @Action({ rawError: true })
  async getRatingsByOffice(practiceId: number): Promise<void> {
    const ratings = await RatingService.getByPracticeAsync(practiceId);

    if (!this.ratingData) {
      return;
    }

    const ratingOpenStatus = RatingStatus.Open.getId(this.ratingData.ratingStatuses);

    const openRatings = ratings
      .filter(rating => rating.status === ratingOpenStatus);

    const closedRatings = ratings
      .filter(rating => rating.status !== ratingOpenStatus);

    this.context.commit("updateField", {
      path: "openRatings",
      value: openRatings
    });

    this.context.commit("updateField", {
      path: "closedRatings",
      value: closedRatings.sort((a, b) => b.startDateOnly.toString().localeCompare(a.startDateOnly.toString()))
    });
  }

  @Action({ rawError: true })
  async updateRating(form: RatingFormDto): Promise<void> {
    try {
      await RatingService.updateAsync(form);
    } catch (e) {
      console.error(e);
    }
  }
}

Ratings.getters = { getField };
Ratings.mutations = { updateField };

export default Ratings;